import * as companyConfigsApi from '../api/companyConfigs';
import { COMPANY } from '../constants';

export const getConfigs = async (configType) => {
  const companyConfigs = await companyConfigsApi.getAllCompanyConfigs(COMPANY);
  const { payload } = companyConfigs.find(({ type }) => type._id === configType) || {};
  return payload;
};
